import { DirectionalLight, AmbientLight, HemisphereLight, SpotLight } from 'three';

class Lights {

    constructor(boundingSphere, lightColorDark, lightColorNeutral, lightColorBright, lightOpacity) {
        this.boundingSphere = boundingSphere;
        this.lightColorDark = lightColorDark || '#303030';
        this.lightColorNeutral = lightColorNeutral || '#606060';
        this.lightColorBright = lightColorBright || '#909090';
        this.lightOpacity = lightOpacity || 0.75;
    }

    createLights() {
        var offset = this.boundingSphere.radius * 6; // get the radius of the bounding sphere for placing lights at certain distance from the object
        var center = this.boundingSphere.center; // get the center of the bounding sphere for pointing lights at it

        // the sun as directional light
        this.sunLight = new DirectionalLight(this.lightColorDark);
        this.sunLight.name = "The sun :)";
        this.sunLight.position.set(center.x + offset, center.y + offset, -center.z - offset);
        this.sunLight.position.multiplyScalar(50);
        this.sunLight.target.position.set(center.x, center.y, center.z);
        // create a global ambient light object
        this.ambientLight = new AmbientLight(this.lightColorDark);
        this.ambientLight.name = "Mild ambient light";
        // create a hemisphere light object
        this.hemisphereLight = new HemisphereLight(this.lightColorDark, this.lightColorBright, this.lightOpacity);
        this.hemisphereLight.name = "Mild hemisphere light";
        this.hemisphereLight.position.set(center.x + offset, center.y + offset, center.z + offset);
        let spotLight1 = new SpotLight(this.lightColorBright, this.lightOpacity);
        spotLight1.position.set(-center.x - offset / 2, center.y + offset / 1.5, -center.z - offset / 2);
        spotLight1.target.position.set(center.x, center.y, center.z);
        let spotLight2 = new SpotLight(this.lightColorNeutral, this.lightOpacity);
        spotLight2.position.set(center.x + offset / 2, center.y + offset / 1.5, -center.z - offset / 2);
        spotLight2.target.position.set(center.x, center.y, center.z);
        // create 2 spotlights
        this.spotLights = [spotLight1, spotLight2];
    }

    applyLights(scene, privot) {
        this.createLights();

        if (this.sunLight instanceof DirectionalLight)
            scene.add(this.sunLight);

        if (this.ambientLight instanceof AmbientLight)
            scene.add(this.ambientLight);

        if (this.hemisphereLight instanceof HemisphereLight)
            scene.add(this.hemisphereLight);

        if (this.spotLights !== null && typeof this.spotLights === 'object' && this.spotLights.constructor === Array) {
            this.spotLights.forEach(spotLight => {
                privot.add(spotLight);
            });
        }
    }
}

export { Lights as default };
